import React, { useEffect, useRef, useState } from "react";
import './header.css';  // Import the CSS file for styling
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

function Header({ skillsRef, projectRef }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null); // 드롭다운 참조
    const iconRef = useRef(null); // 아이콘 참조

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // 부드럽게 스크롤
        });
      };

      const scrollToBottom = () => {
        window.scrollTo({
          top: document.documentElement.scrollHeight, // 페이지의 전체 높이로 스크롤
          behavior: 'smooth', // 부드럽게 스크롤
        });
      };

    const scrollToSkills = () => {
        // skillsRef가 있으면 해당 섹션으로 부드럽게 스크롤
        if (skillsRef && skillsRef.current) {
          skillsRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      };

      const scrollToProjects = () => {
        // skillsRef가 있으면 해당 섹션으로 부드럽게 스크롤
        if (projectRef && projectRef.current) {
            projectRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      };

    // Toggle dropdown visibility when the icon is clicked
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            // 클릭한 곳이 드롭다운 또는 아이콘 외부일 때
            if (
                dropdownRef.current && !dropdownRef.current.contains(event.target) &&
                iconRef.current && !iconRef.current.contains(event.target)
            ) {
                setIsOpen(false); // 드롭다운 닫기
            }
        };

        // 문서에 클릭 이벤트 리스너 추가
        document.addEventListener('click', handleClickOutside);

        // 컴포넌트가 언마운트될 때 리스너 제거
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className="header">
            <div className="header-container">
                <div className="header-item" onClick={scrollToTop}><span>Main</span></div>
                <div className="header-item" onClick={scrollToSkills}><span>Skills</span></div>
                <div className="header-item" onClick={scrollToProjects}><span>Projects</span></div>
                <div className="header-item" onClick={scrollToBottom}><span>Etc</span></div>
                <div className="header-item-icon" ref={iconRef} onClick={toggleDropdown}>
                    <div className="icon"><FontAwesomeIcon icon={faGlobe} /></div>
                </div>
            </div>
        
            {/* Dropdown은 isOpen이 true일 때만 보임 */}
            {/* <div className={`dropdown ${isOpen ? 'open' : ''}`} ref={dropdownRef}>
                <div className="dropdown-item">한국어</div>
                <div className="dropdown-item">English</div>
            </div> */}
        </div>
    );
}

export default Header;
